import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { I18nT } from 'vue-i18n';

import ClientPlugin from '@plugins/client';
import ColorPlugin from '@plugins/color';
import ExceptionPlugin from '@plugins/exceptions';
import FontStylePlugin from '@plugins/font-style';
import HttpStatusPlugin from '@plugins/http-status';
import ModalPlugin from '@plugins/modal';
import SpacingPlugin from '@plugins/spacing';
import SymbolStylePlugin from '@plugins/symbol-style';
import App from '@/App.vue';
import router from '@/router';
import i18n, { loadLocale } from '@/i18n';
import dayjs from '@/time';

const app = createApp(App);
const store = createPinia();

dayjs(); // ensures `time.ts` is loaded first.

app
  .use(store)
  .use(router)
  .use(i18n)
  .use(ClientPlugin)
  .use(ColorPlugin)
  .use(ExceptionPlugin)
  .use(FontStylePlugin)
  .use(HttpStatusPlugin)
  .use(ModalPlugin)
  .use(SpacingPlugin)
  .use(SymbolStylePlugin)
  .component('i18n-t', I18nT)
  .mount('#app');

loadLocale();
